import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { Route, Switch, NavLink } from 'react-router-dom';

import FeaturedArtists from './featured-artists';
import TopArtists from './top-artists';
import Genre from './genre';
import GenreList from './genre-list';
import HFMPicks from './hfm-picks';
import HomepageHero from './homepage-hero';

@inject('artistStore')
@observer
class Browse extends React.Component {
	state = {
		active: 'featured-artists'
	};

	render() {
		const { active } = this.state;
		const LinkItem = ({ activeSlug, label, to }) => (
			<NavLink
				className={ `primary-link ${active === activeSlug ? 'active' : ''}` }
				onClick={ () => { this.setState({active: activeSlug}) } }
				exact to={ to }
			>
				{ label }
			</NavLink>
		);

		return (
			<div>
				<HomepageHero />
				<div className="grid-x grid-padding-x padding-top-1 padding-bottom-3">
					<div className="cell">
						<Route path="/browse/featured-artists" component={ FeaturedArtists } />
						<Route path="/browse/top-artists" component={ TopArtists } />
						<Route exact path="/browse/genres" component={ GenreList } />
						<Route exact path="/browse/genres/:id" component={ Genre } />
						<Route path="/browse/hfm-picks" component={ HFMPicks } />
					</div>
				</div>

				<div className="margin-left-1">
					<Switch>
						<Route path="/browse/genres/:id">

						</Route>
						<Route>
							<HFMPicks/>
						</Route>
					</Switch>
				</div>
				{/*Hide Genres for now, until there's enough content to justify them being there.*/}
				{/* <div className="genres-container">
				<Switch>
					<Route path="/browse/genres/:id">

					</Route>
					<Route>
						<GenreList/>
					</Route>
				</Switch>
				</div> */}
			</div>
		);
	}
}

export default Browse;
